import { CSSProperties } from "react";

interface DocumentTextIconProps {
  className?: string;
  width?: string;
  size?: string;
  height?: string;
  style?: CSSProperties;
  color?: string;
  title?: string;
  isSelected?: boolean;
  noPointer?: boolean;
}

const DocumentTextIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title,
  isSelected
}: DocumentTextIconProps) => {
  const getColor = () => {
    if (isSelected) return "var(--color-easil-black)";
    return color || "var(--color-easil-gray-x-dark)";
  };

  return (
    <svg
      className={className}
      style={style}
      data-no-pointer={noPointer}
      width={width || size || 20}
      height={height || size || 20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="title"
    >
      <title>{title}</title>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h20v20H0z" />
        <g strokeWidth="2">
          <path
            stroke={getColor()}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M16 4v12"
          />
          <path
            stroke={getColor()}
            d="M13 3h1a2 2 0 0 1 2 2 2 2 0 0 1 2-2h1m0 14h-1a2 2 0 0 1-2-2 2 2 0 0 1-2 2h-1"
          />
        </g>
        <g
          stroke={getColor()}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path d="M11 8H7V4" />
          <path d="M3.5 4h3.672a2 2 0 0 1 1.414.586l1.828 1.828A2 2 0 0 1 11 7.828V14.5A1.5 1.5 0 0 1 9.5 16h-6A1.5 1.5 0 0 1 2 14.5v-9A1.5 1.5 0 0 1 3.5 4" />
        </g>
      </g>
    </svg>
  );
};

export default DocumentTextIcon;
